import ThemeService from "../../../shared/services/ThemeService";
import { db } from "../../../shared/plugins/firebase-app";

const themeService = new ThemeService(db);
export default themeService;
